import { gql } from "@apollo/client";
import { useQuery } from "@apollo/client/react";
import { useMemo, useState } from "react";

import BimClassCard from "./BimClassCard";
import ListBimClasses from "./ListBimClasses.graphql";
import InventoryMenu from "../../../components/InventoryMenu";
import InventorySearch from "../../../components/InventorySearch";
import LetterGroups from "../../../components/Letters/LetterGroups";
import Letters from "../../../components/Letters/Letters";

function firstLetterSelector(bimClass) {
    return bimClass.data.name[0].text.toLowerCase()[0];
}

const filters = {
    all: () => true,
    published: (bimClass) => {
        return bimClass.metadata.tags.includes("public");
    },
    unpublished: (bimClass) => {
        return !bimClass.metadata.tags.includes("public");
    },
    deprecated: (bimClass) => {
        return bimClass.metadata.deprecated;
    },
    nondeprecated: (bimClass) => {
        return !bimClass.metadata.deprecated;
    },
};

export default function BimClassList(props) {
    const { guard } = props;
    const listBimClasses = useQuery(gql(ListBimClasses));
    const bimClasses = listBimClasses.data?.bimClasses ?? [];

    const [textSearch, setTextSearch] = useState("");
    const [filter, setFilter] = useState("nondeprecated");

    const matchingBimClasses = useMemo(
        () => bimClasses
            .filter(
                (bimClass) => filters[filter](bimClass) ?? true
            )
            .filter(
                (bimClass) => [
                    bimClass.data.name[0].text.toLowerCase().includes(textSearch.toLowerCase()),
                    bimClass.id.toLowerCase().replaceAll("-", "").includes(textSearch.toLowerCase().replaceAll("-", "")),
                ].includes(true)
            )
            .sort(
                (a, b) => a.data.name[0].text.localeCompare(b.data.name[0].text),
            ),
        [bimClasses, filter, textSearch],
    );

    if (listBimClasses.loading) return "loading";
    if (listBimClasses.error) return "error";

    return (
        <>
            <InventoryMenu>
                <Letters
                    active={ matchingBimClasses }
                    all={ bimClasses }
                    selector={ firstLetterSelector }
                />
                <InventorySearch
                    onChange={ (e) => setTextSearch(e.target.value) }
                    placeholder="search BimClasses"
                    value={ textSearch }
                />
                <select
                    onChange={ (event) => setFilter(event.target.value)  }
                    value={ filter }
                >
                    {
                        Object
                            .keys(filters)
                            .map(
                                (f) => (
                                    <option key={ f } value={ f }>{ f }</option>
                                )
                            )
                    }
                </select>
            </InventoryMenu>
            <LetterGroups
                items={ matchingBimClasses }
                render={
                    (bimClass) => (
                        <BimClassCard
                            guard={ guard }
                            bimClass={ bimClass }
                            key={ bimClass.id }
                        />
                    )
                }
                selector={ firstLetterSelector }
            />
        </>
    );
}
